import { render, staticRenderFns } from "./ExpenseCreation.vue?vue&type=template&id=45a6974c&scoped=true"
import script from "./ExpenseCreation.vue?vue&type=script&lang=js"
export * from "./ExpenseCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6974c",
  null
  
)

export default component.exports